import _ from 'lodash'

import { SET_CLIENT_NAME } from './actions.js'
import {
  SPEC_DATA,
  SPEC_DATA_SUCCESS,
  SPEC_DATA_FAIL,
  COMPARTMENT_RECEIVE,
  COMPARTMENT_RECEIVE_FAIL,
  COMPARTMENT_RECEIVE_SUCCESS
} from './patientActions.js'
import { PATIENT_BANNER_RESET } from './PatientBanner/actions.js'

const initialState = {}

const indexCompartmentByResourceTypeAndId = compartment =>
  _.mapValues(
    _.groupBy(compartment, r => r.resourceType),
    resources =>
      _.reduce(
        resources,
        (acc, r) => {
          acc[r.id] = r
          return acc
        },
        {}
      )
  )

export default function reducer (state = initialState, action) {
  const { clientName, patientId, compartment, specPercentage } = action
  switch (action.type) {
    case COMPARTMENT_RECEIVE:
      return {
        ...state,
        loading: true
      }
    case COMPARTMENT_RECEIVE_FAIL:
      return {
        ...state,
        loading: false
      }
    case COMPARTMENT_RECEIVE_SUCCESS:
      return {
        ...state,
        clientName,
        loading: false,
        id: patientId,
        compartment: { ...indexCompartmentByResourceTypeAndId(compartment) }
      }
    case SPEC_DATA:
      return {
        ...state,
        loadingSpec: true
      }
    case SPEC_DATA_FAIL:
      return {
        ...state,
        loadingSpec: false
      }
    case SPEC_DATA_SUCCESS:
      return {
        ...state,
        clientName,
        loadingSpec: false,
        id: patientId,
        specPercentage
      }
    case SET_CLIENT_NAME:
      return {
        ...state,
        clientName: action.clientName
      }
    case PATIENT_BANNER_RESET:
      return { ...initialState }
    default:
      return state
  }
}
